import { useState, useEffect, useContext } from "react";
import Modal from "@mui/material/Modal";
import { useNavigate } from "react-router-dom";
import { Box, Button, IconButton, InputLabel, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReactInputVerificationCode from "react-input-verification-code";
import user from "src/components/UI/Shared/user";
// assets
import styles from "src/components/UI/Home/Menu/assets/scss/LockPopup.module.scss";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

interface LockPopupProps {
  openModal: boolean;
  onClose: () => void;
}
const LockPopup = ({ openModal, onClose }: LockPopupProps) => {
  const dispatch = useDispatch();
  const [enteredLockCode1, setEnteredLockCode1] = useState("");
  const [enteredLockCode2, setEnteredLockCode2] = useState("");
  const [notMatch, setNotMatch] = useState(false);

  let navigate = useNavigate();

  const handleContinue = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault();
    if (Number(enteredLockCode1) === Number(enteredLockCode2)) {
      user.setLoggedInLockCode(enteredLockCode1);
      navigate("identity/lock");
      dispatch(
        appActions.setNotification({
          open: true,
          message: "Lock code is set successfully.",
          severity: "success",
        })
      );
    } else {
      setNotMatch(true);
    }
  };
  useEffect(() => {
    if (enteredLockCode1[0] !== "-" || enteredLockCode2[0] !== "-") {
      setNotMatch(false);
    }
  }, [enteredLockCode1, enteredLockCode2]);
  return (
    <Modal
      open={openModal}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={styles.backdrop}
    >
      <Box className={styles.box}>
        <IconButton
          className={styles.iconButton}
          disableRipple
          aria-label="Close"
          onClick={onClose}
        >
          <CloseIcon
            sx={{ fontSize: "1rem", color: "#c3e7ff75", fontWeight: "900" }}
          />
        </IconButton>

        <form className={styles.form}>
          <div
            className={`${styles.inputRow} ${
              notMatch ? styles.inputRowError : ""
            }`}
          >
            <InputLabel sx={{ left: "-5rem" }}>Enter lock code:</InputLabel>
            <ReactInputVerificationCode
              length={4}
              placeholder="—"
              autoFocus
              onChange={(val: string) => {
                setEnteredLockCode1(val);
              }}
              value={enteredLockCode1}
            />
          </div>
          <div
            className={`${styles.inputRow} ${
              notMatch ? styles.inputRowError : ""
            }`}
            style={{ marginBottom: `${notMatch ? "0.5rem" : "0.9rem"}` }}
          >
            <InputLabel sx={{ left: "-4.25rem" }}>
              Re-enter lock code:
            </InputLabel>

            <ReactInputVerificationCode
              length={4}
              placeholder="—"
              autoFocus={Boolean(Number(enteredLockCode1))}
              onChange={(val: string) => {
                setEnteredLockCode2(val);
              }}
              value={enteredLockCode2}
            />
          </div>
          {notMatch && (
            <div className={styles.helperText}>
              <Typography>Inputs do not match.</Typography>
            </div>
          )}
          <div
            className={`${styles.buttonDiv} ${
              notMatch ? styles.buttonDivError : ""
            }`}
          >
            <Button
              type="submit"
              variant="contained"
              disabled={
                !Boolean(Number(enteredLockCode1)) ||
                !Boolean(Number(enteredLockCode2))
              }
              className={`${styles.button}  `}
              onClick={handleContinue}
            >
              Save
            </Button>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default LockPopup;
